import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetEmailTemplates } from "src/app/store/email-template/email-template.action";

export function EmailTemplatesResolver() {
    return inject(Store).dispatch(new GetEmailTemplates());
}